/**
 * Cockpit Manage - English (US)
 * 驾驶舱管理 - 美式英语
 */
export default {
  title: 'Cockpit',
  targetManage: 'Target Management',
  performanceReview: 'Performance Review',
  setTarget: 'Set Target',
  newTarget: 'New Target',
  addTarget: 'Add Target',
  currentMonthTarget: 'Current Month Target',
  targetIncome: 'Target Income',
  currentIncome: 'Current Income',
  actualIncome: 'Actual Income',
  completionRate: 'Completion',
  timeProgress: 'Time Progress',
  daysRemaining: '{n} days left',
  notStarted: 'Not started',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  operationReminder: 'Operation Reminder',
  deleteTargetConfirm: 'Deleting this target will clear submitted performance data and all related sales tasks. Continue?',
  exit: 'Exit',
  targetDetail: 'Target Detail',
  targetSetting: 'Target Setting',
  targetPeriod: 'Target Period',
  selectMonth: 'Select month',
  machinePart: 'Learning Device',
  estimatedRevenue: 'Estimated Revenue',
  estimatedTip: '(Estimated by official reference price)',
  model: 'Model',
  targetQty: 'Target Qty',
  supervisorPart: 'Supervisor',
  optional: 'Optional',
  totalTargetIncome: 'Total Target Income',
  nextStepAssign: 'Next: Assign Target',
  viewAssignTarget: 'View Assigned Target',
  assignTip: 'Targets have been auto-assigned to sub-agents. You may adjust [Qty] and [Supervisor Income] manually.',
  addOrRemoveAgent: 'Add/Remove Agent',
  ratioMode: 'Edit by Ratio',
  incomeMode: 'Edit by Income',
  resetToDefault: 'Reset to Default',
  machineIncomeRatio: 'Device Income Ratio',
  machineIncome: 'Device Income',
  supervisorIncomeRatio: 'Supervisor Income Ratio',
  supervisorIncome: 'Supervisor Income',
  totalIncomeTarget: 'Total Income Target',
  yuan: 'yuan',
  agentId: 'Agent ID',
  placeholderAgentId: 'Enter agent ID',
  campusId: 'Campus ID',
  placeholderCampusId: 'Enter campus ID',
  clearFilter: 'Clear filter',
  agent: 'Agent',
  agentType: 'Agent Type',
  targetName: 'Target Name',
  campusIdCol: 'Campus ID',
  totalIncomeTargetCol: 'Total Income Target',
  totalIncomeAchieved: 'Total Income Achieved',
  totalIncomeCompletion: 'Total Income Completion',
  qtyTarget: 'Qty Target',
  qtyAchieved: 'Qty Achieved',
  qtyCompletion: 'Qty Completion',
  qtyDetail: 'Qty Detail',
  machineIncomeTarget: 'Device Income Target',
  machineIncomeAchieved: 'Device Income Achieved',
  machineIncomeCompletion: 'Device Income Completion',
  supervisorIncomeTarget: 'Supervisor Income Target',
  supervisorIncomeAchieved: 'Supervisor Income Achieved',
  supervisorIncomeCompletion: 'Supervisor Income Completion',
  machineModel: 'Device Model',
  total: 'Total',
  backToTargetSetting: 'Back to target setting',
  addRemoveAgent: 'Add/Remove agents',
  select: 'Select',
  submitTargetConfirm: 'After submission, the target will be assigned to the selected agents and take effect on',
  submitTargetConfirmEnd: '. Confirm to submit?',
  submitTargetConfirmFull: 'After submission, the target will be assigned to the selected agents and take effect on {date}. Confirm?',
  effectiveDate: '{month}/1/{year}',
  switchModeConfirm: 'Switch input mode?',
  switchModeTip: 'All agent income ratios will be recalculated. Continue?',
  dealerId: 'Agent ID',
  dealerName: 'Agent name',
  queryFailed: 'Query failed',
  selectTargetPeriod: 'Please select target period',
  performanceReviewExport: 'Performance review export',
  selectTargetPeriodRequired: 'Please select target period!',
  fillMachineQtyRequired: 'Please fill in at least one machine model quantity!',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  assignTargetToDealer: 'Please assign target to at least one agent',
  machineIncomeRatio100: 'Machine income ratio total must be 100%',
  supervisorIncomeRatio100: 'Supervisor income ratio total must be 100%',
  targetSuffix: ' target',
  machineTotalNotMatchTarget: 'Total machine income does not match target. Please adjust.',
  supervisorTotalNotMatchTarget: 'Total supervisor income does not match target. Please adjust.',
};
